import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import RawText from './RawText';
import styles from './Caption.st.css';
import Ellipsis, { extractEllipsisProps } from '../common/Ellipsis';

var CaptionWithEllipsis = function CaptionWithEllipsis(_ref) {
  var className = _ref.className,
      caption = _ref.caption,
      props = _objectWithoutProperties(_ref, ["className", "caption"]);

  var _extractEllipsisProps = extractEllipsisProps(props),
      ellipsisProps = _extractEllipsisProps.ellipsisProps,
      componentProps = _extractEllipsisProps.componentProps;

  return /*#__PURE__*/React.createElement(Ellipsis, _extends({}, ellipsisProps, {
    // TODO - with Stylable3 change to wrapperClassName
    wrapperClasses: {
      className: styles[caption]
    },
    render: function render(_ref2) {
      var ref = _ref2.ref,
          ellipsisClasses = _ref2.ellipsisClasses;
      return /*#__PURE__*/React.createElement(RawText, _extends({}, componentProps, {
        size: "medium",
        weight: "bold",
        ref: ref
      }, styles('root', {
        caption: caption
      }, {
        className: ellipsisClasses(className)
      })));
    }
  }));
};

CaptionWithEllipsis.displayName = 'Caption';
CaptionWithEllipsis.propTypes = _objectSpread(_objectSpread({}, RawText.propTypes), Ellipsis.propTypes);
CaptionWithEllipsis.defaultProps = _objectSpread(_objectSpread({}, RawText.defaultProps), Ellipsis.defaultProps);
export default CaptionWithEllipsis;